import React from 'react';
import * as S from './ConfirmationModal.styled'
import { Modal } from 'uol-host-react-ui'

export function getSplitedTitle(title: string) {
    const titleFirstWord = title.split(' ')[0]
    const titleRest = title.slice(title.indexOf(title.split(' ')[1]))

    return { titleFirstWord, titleRest }
}

export interface ConfirmationModalProps {
    buttonClick(): void;
    isOpen: boolean;
    setIsOpen(value: boolean): void;
    title: string,
    description: string,
    actionButtonDescription: string,
}

export const ConfirmationModal: React.FC<ConfirmationModalProps> = ({ buttonClick, isOpen, setIsOpen, title, description, actionButtonDescription }: ConfirmationModalProps) => {
    const { titleFirstWord, titleRest } = getSplitedTitle(title)


    return (
        <Modal
            onClose={() => { setIsOpen(false) }}
            show={isOpen}
            style={{ maxWidth: 520 }}
            data-testid='modal'
        >
            <S.ModalHeader>
                <S.Title>
                    <S.TitleColor>{titleFirstWord}</S.TitleColor> {titleRest}
                </S.Title>
            </S.ModalHeader>
            <div>
                <S.ModalText>
                    {description}
                </S.ModalText>

                <S.ModalButton>
                    <S.ButtonCustom variant='secondary' width='120px' onClick={() => setIsOpen(false)}>Voltar</S.ButtonCustom>
                    <S.ButtonCustom variant='brand_uh' width='245px' onClick={() => buttonClick()}>{actionButtonDescription}</S.ButtonCustom>
                </S.ModalButton>
            </div>
        </Modal>
    )
}